<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-16 11:06:08
 * @name: 特价审批
 * @Description: 特价审批
 * @FilePath: \preSaleNafterSaleInside\project\src\views\index\bargainPrice\bargainPriceRouter.vue
 * @Author: desktop
-->
<template>
  <div>

  </div>
</template>
<script>
export default {
  name: 'indexBargainPrice',  
}
</script>
<style lang="scss" scoped>

</style>